import BaseComponent from "../baseComponent.js";
import styles from "./modal.scss";

export default class DisconnectionModal extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState() {
    return {
      message: 'Trying to Reconnect to Smash.bi',
      reconnected: false
    };
  }

  componentDidMount() {
    this.$modal = $("#disconnection-modal");
    this.$modal.modal({
      dismissible: false
    });
  }

  show() {
    this.setState(this.getInitialState());
    $("#app-bar").css('z-index', '100');
    this.$modal.modal("open");
  }

  hide() {
    this.$modal.modal("close");
  }

  reload() {
    document.location.href = "/";
  }

  reconnected() {
    this.setState({
      message: 'Reconnected',
      reconnected: true
    });
  }

  render() {
    return (
      <div id="disconnection-modal" className={[styles.modal, "modal"].join(' ')} style={{width: '450px'}}>
        <div className="modal-content">
          <h5>{this.state.message}</h5>
        </div>
        {
          this.state.reconnected ?
            null :
            <div className={styles.footer}>
              <button className={[styles.actionButton, "btn waves-effect"].join(' ')} onClick={this.reload}>Login
                Again
              </button>
            </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/disconnectionModal.jsx